import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
    .use(HttpApi) // טוען תרגומים מהשרת/תיקיית public
    .use(LanguageDetector) // מזהה את שפת המשתמש
    .use(initReactI18next) // מחבר ל-React
    .init({
        supportedLngs: ['he', 'en'], // השפות הנתמכות
        fallbackLng: 'he', // שפת ברירת מחדל
        debug: true, // מציג לוגים בקונסולה, טוב לפיתוח

        // הגדרות זיהוי השפה
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
        },

        // הגדרות לטעינת קבצי התרגום
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        },

        react: {
            useSuspense: true, // מומלץ להשתמש ב-Suspense
        }
    });

export default i18n;